




















































































import { ApplipcationStoreType, LanguageType } from "@/enums/enums";
import { MerchantId } from "@/helper/userHelper";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreLogIn = namespace("LogIn");

@Component
export default class SideBar extends Vue {
  private listMenu = [
    {
      name: "Menu_Dashboard",
      icon: "",
      img: require("@/assets/img/menubar/ic_dashboard.png"),
      link: { name: "home" },
    },
    {
      name: "Menu_Custom",
      icon: "",
      img: require("@/assets/img/menubar/ic_custom.png"),
      link: { name: "custom" },
    },
    {
      name: "Menu_Follow",
      icon: "",
      img: require("@/assets/img/menubar/ic_follow.png"),
      link: { name: "" },
      lock: { value: true, text: "Lock_HeaderMenu" },
    },
    {
      name: "Menu_Analyst",
      icon: "",
      img: require("@/assets/img/menubar/ic_analyst.png"),
      link: { name: "executiveSummary" },
    },
    {
      name: "Menu_Setting",
      icon: "",
      img: require("@/assets/img/menubar/ic_setting.png"),
      link: { name: "" },
      lock: { value: true, text: "Lock_HeaderMenu" },
    },
  ];
  private langs = [
    { name: "ภาษาไทย", languageType: LanguageType.Th, active: false },
    { name: "English", languageType: LanguageType.En, active: false },
  ];
  private blobUrl = process.env.VUE_APP_PeakBlobStorage;

  @StoreLogIn.Getter
  private getUserModel!: any;

  @StoreLogIn.Action
  private DoRedirectByApplipcationStore!: (applipcationStoreType: ApplipcationStoreType) => void;

  get isCanUsePeakPayroll() {
    return this.$can("access", "PeakPayroll");
  }
  get isCanUsePeakTax() {
    return this.$can("access", "PeakTax");
  }
  get isCanUsePeakAsset() {
    return this.$can("access", "PeakAsset");
  }

  @Watch("$i18n.locale", { immediate: true })
  localeChanged() {
    switch (this.$i18n.locale) {
      case "th":
        this.SetLang(LanguageType.Th);
        break;
      case "en":
        this.SetLang(LanguageType.En);
        break;
    }
  }

  public SetLang(languageType: LanguageType) {
    switch (languageType) {
      case LanguageType.Th:
        this.$i18n.locale = "th";
        break;
      case LanguageType.En:
        this.$i18n.locale = "en";
        break;
    }

    this.langs.forEach((lang) => {
      if (lang.languageType == languageType) {
        lang.active = true;
      } else {
        lang.active = false;
      }
    });
  }

  public RedirectToPeak() {
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.Peak);
    this.Hide();
  }
  public RedirectToNewPeak() {
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.NewPeak);
    this.Hide();
  }
  public RedirectToPeakPayroll() {
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.Payroll);
    this.Hide();
  }
  public RedirectToPeakBoard() {
    this.$router
      .push({
        name: "home",
        query: { emi: MerchantId().PeakEncryption() },
      })
      .catch((err) => {
        return "";
      });
    this.Hide();
  }
  public RedirectToPeakAsset() {
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.Asset);
    this.Hide();
  }
  public RedirectToPeakTax() {
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.Tax);
    this.Hide();
  }
  public LinkToLogout() {
    this.$router.push({ name: "logout" });
    this.Hide();
  }
  public LinkTo(link: any) {
    this.$router
      .push({
        name: link.name,
        query: { emi: MerchantId().PeakEncryption() },
      })
      .catch((err) => {
        return "";
      });
    this.Hide();
  }

  public Hide() {
    this.$emit("update:showSideBar", false);
  }
}
